module.exports = __webpack_public_path__ + "static/media/sample_upload_eway_expiry.b02218fa.csv";